import React, { useState } from "react";
import "../static/css/AdminGallery.css";
import axios from "axios";

function PublicationPage() {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [des, setDes] = useState("");
  const [activeTab, setActiveTab] = useState("Anniversary");
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("title", title);
    formData.append("content", content);
    formData.append("image", file);

    let endpoint = "";
    if (activeTab === "Anniversary") {
      formData.append("year", title);
      endpoint = "https://skpbackend.quindl.com/gallery/anniversary";
    } else if (activeTab === "Seminar") {
      endpoint = "https://skpbackend.quindl.com/gallery/seminar";
    } else if (activeTab === "Award") {
      endpoint = "https://skpbackend.quindl.com/gallery/award";
    }

    try {
      const response = await axios.post(endpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log(response.data);
    } catch (error) {
      console.error("There was an error uploading the file!", error);
    }
  };

  return (
    <>
      <div className="Admincontrol">
        <div className="admincontrol-form">
          <div className="gallery-buttons">
            <button
              className={activeTab === "Anniversary" ? "active" : ""}
              onClick={() => setActiveTab("Anniversary")}
            >
              Anniversary
            </button>
            <button
              className={activeTab === "Seminar" ? "active" : ""}
              onClick={() => setActiveTab("Seminar")}
            >
              Seminar
            </button>
            <button
              className={activeTab === "Award" ? "active" : ""}
              onClick={() => setActiveTab("Award")}
            >
              Award
            </button>
          </div>
          <form onSubmit={handleSubmit}>
            <label htmlFor="title">
              {activeTab === "Anniversary"
                ? "Year"
                : activeTab === "Seminar"
                ? "Seminar Name"
                : "Award Name"}
            </label>
            <input
              id="title"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder={
                activeTab === "Seminar"
                  ? "Enter seminar name"
                  : activeTab === "Award"
                  ? "Enter award name"
                  : "Enter year"
              }
            />

            {activeTab !== "Anniversary" && (
              <>
                <label htmlFor="content">
                  {activeTab === "Seminar"
                    ? "Seminar Description"
                    : "Award Description"}
                </label>
                <input
                  id="content"
                  type="text"
                  value={content}
                  onChange={(e) => setContent(e.target.value)}
                  placeholder={
                    activeTab === "Seminar"
                      ? "About Seminar"
                      : "About the Award"
                  }
                />
              </>
            )}

            <label htmlFor="file">Upload Image</label>
            <div className="file-upload">
              <input id="file" type="file" onChange={handleFileChange} />
              <span className="file-upload-placeholder">
                <i className="upload-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.66667 24C1.93333 24 1.30556 23.7389 0.783333 23.2167C0.261111 22.6944 0 22.0667 0 21.3333V2.66667C0 1.93333 0.261111 1.30556 0.783333 0.783333C1.30556 0.261111 1.93333 0 2.66667 0H21.3333C22.0667 0 22.6944 0.261111 23.2167 0.783333C23.7389 1.30556 24 1.93333 24 2.66667V21.3333C24 22.0667 23.7389 22.6944 23.2167 23.2167C22.6944 23.7389 22.0667 24 21.3333 24H2.66667ZM2.66667 21.3333H21.3333V2.66667H2.66667V21.3333ZM4 18.6667H20L15 12L11 17.3333L8 13.3333L4 18.6667Z"
                      fill="#828282"
                    />
                  </svg>
                </i>
                Upload Image
              </span>
            </div>
            <button type="submit">Submit</button>
          </form>
        </div>
      </div>
    </>
  );
}

export default PublicationPage;
